import { CatalogueState } from "../state/catalogueState";
import {
  RECEIVE_CATALOGUE_LIST,
  RECEIVE_CATALOGUE_CATEGORIES,
  SET_URL_CATEGORY,
  IS_LOADING,
  CLEAR_FILTERS,
  UPDATE_FILTERS,
  RECEIVE_CATALOGUE,
  RECEIVE_CATALOGUE_ITEM,
  RECEIVE_CREATED_ORDER,
  RECEIVE_DECORATION_TYPE,
  RECEIVE_DECORATION_LOCATIONS,
  UPDATE_CURRENT_ORDER,
  RECEIVE_CARTWORK_DETAILS,
  RECEIVE_CARTWORKS_LIST_BYID,
  RECEIVE_CARTWORKS_LIST,
  RECEIVE_DECORATORS_TYPE_LIST,
  RECEIVE_DECORATORS_VENDORS_LIST,
  RECEIVE_SIPPING_LOCATION
} from '../actions/catalogueActions'
import { RECEIVE_CURRENT_USER } from '../actions/sessionActions'
import { User } from '../../models/User'

export const initState: CatalogueState = {
  fetchError: false,
  catalogues: {},
  filters: {
    categoryName: '',
    inhouseId: '',
    productName: '',
    productId: '',
    mainSearch: '',
  },
  urlCategory: '',
  catalogueCustomRows: [],
  decoratorsTypeList: [],
  decoratorsVendorsList: [],
  shippingLocations: [],
  currentOrder: [],
  categories: [],
  artworkDetails: {},
  artworkList: {},
  artworkListById: {},
  loading: false,
  cleared: 0,
  page: 0,
  meta: null,
  count: 1,
}

const CatalogueReducer = (state: CatalogueState = initState, action) => {
  switch (action.type) {
    case RECEIVE_CURRENT_USER: {
      const currentUser: User = action.currentUser
      if (
        currentUser.portalPermissions &&
        currentUser.portalPermissions.Catalogue[0].allowedOtherContacts
      ) {
        return {
          ...state,
          statuses:
            currentUser.portalPermissions &&
            currentUser.portalPermissions.Catalogue[0].allowedStatus,
          filters: {
            ...state.filters,
            account_id: action.currentUser.accountId,
            contact_id: !action.currentUser.portalPermissions.Catalogue[0]
              .allowedOtherContacts
              ? action.currentUser.contactId
              : '',
          },
        }
      } else {
        return {
          ...state,
          statuses: currentUser.portalPermissions.Catalogue[0].allowedStatus,
          filters: {
            ...state.filters,
            account_id: action.currentUser.accountId,
            contact_id: !action.currentUser.portalPermissions.Catalogue[0]
              .allowedOtherContacts
              ? action.currentUser.contactId
              : '',
          },
        }
      }
    }
    case RECEIVE_DECORATION_LOCATIONS: {
      return {
        ...state,
        loading: false,
        decorationLocations: action.payload.data,
      }
    }
    case RECEIVE_DECORATION_TYPE: {
      return {
        ...state,
        loading: false,
        decorationTypes: action.payload.data,
      }
    }
    case RECEIVE_CATALOGUE_LIST: {
      return {
        ...state,
        loading: false,
        catalogues: { ...action.catalogues },
        count: action.count,
      }
    }
    case RECEIVE_CARTWORKS_LIST: {
      return {
        ...state,
        loading: false,
        artworkList: action.payload,
      }
    }
    case RECEIVE_CARTWORKS_LIST_BYID: {
      return {
        ...state,
        loading: false,
        artworkListById: action.payload,
      }
    }
    case RECEIVE_DECORATORS_TYPE_LIST: {
      return {
        ...state,
        loading: false,
        decoratorsTypeList: action.payload,
      }
    }
    case RECEIVE_DECORATORS_VENDORS_LIST: {
      return {
        ...state,
        loading: false,
        decoratorsVendorsList: action.payload,
      }
    }
    case RECEIVE_CATALOGUE_CATEGORIES: {
      return {
        ...state,
        loading: false,
        categories: action.payload,
      }
    }
    case RECEIVE_CARTWORK_DETAILS: {
      return {
        ...state,
        loading: false,
        artworkDetails: {
          ...state.artworkDetails,
          [action.payload.data.id]: action.payload.data,
        },
      }
    }
    case SET_URL_CATEGORY: {
      return {
        ...state,
        filters: { ...state.filters, categoryName: action.payload },
        urlCategory: action.payload,
      }
    }
    case UPDATE_CURRENT_ORDER: {
      return {
        ...state,
        currentOrder: action.payload,
      }
    }
    case RECEIVE_CREATED_ORDER: {
      return {
        ...state,
        loading: false,
        catalogueCustomRows: action.payload,
      }
    }
    case RECEIVE_CATALOGUE: {
      return {
        ...state,
        currentOrder: [],
        catalogues: action.payload,
        loading: false,
        fetchError: false,
        count: action.count,
        meta: action.meta,
      }
    }
    case RECEIVE_CATALOGUE_ITEM: {
      return {
        ...state,
        catalogueItem: action.payload,
        loading: false,
        fetchError: false,
      }
    }
    case UPDATE_FILTERS: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      }
    }
    case CLEAR_FILTERS: {
      return {
        ...state,
        filters: {
          ...state.filters,
          inhouseId: '',
          productName: '',
          categoryName: state.urlCategory ? state.urlCategory : '',
          productId: '',
          mainSearch: '',
        },
        cleared: state.cleared + 1,
      }
    }
    case IS_LOADING:
      return {
        ...state,
        loading: action.loading,
      }
      case RECEIVE_SIPPING_LOCATION:
        return {
          ...state,
          shippingLocations: action.payload,
          loading: false,
          fetchError: false,
        }
    default:
      return state
  }
}

export default CatalogueReducer;
